/**
 * Chaikin's Volatility (VOLATI).
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLVolatilidade.cs, classe
 * FML.VOLATI). Painel próprio, 1 linha:
 *
 *   EC     = EMA(H − L, N)
 *   VOLATI = (EC − REF(EC, R)) / REF(EC, R) * 100
 *
 * No engine legado o mesmo N serve para a EMA e para o deslocamento; o ChartIQ
 * expõe os dois separados (Period + Rate of Change Period). Adotado o modelo do
 * ChartIQ (superset): com `rocPeriod` = `period` o resultado é o do legado —
 * é assim que o teste de oráculo prova a paridade. Não confundir com
 * `historicalVolatility` (retornos logarítmicos anualizados).
 * Paridade provada em __tests__/chaikinVolatility.silverlight.test.js.
 */
import { sub, div, mul, ema, ref } from "./silverlightDsl";
import { ChaikinVolatility as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period, rocPeriod } = options;
    const num = (v) => (Number.isFinite(v) ? v : NaN);
    const high = data.map((d) => num(d.high));
    const low = data.map((d) => num(d.low));

    const ec = ema(sub(high, low), period);
    const prev = ref(ec, rocPeriod);
    const volati = mul(div(sub(ec, prev), prev), 100);

    return volati.map((v) => (Number.isFinite(v) ? v : undefined));
  }

  calculator.undefinedLength = function () {
    // O EMA do engine não tem warm-up NaN (seed = f[0]); só o REF atrasa.
    return Math.max(0, options.rocPeriod);
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
